export default "assets/images/icons/medical-ad60db3c.svg";